// extracted by mini-css-extract-plugin
export default {"button":"search_button__tCaOP","button--toggled":"search_button--toggled__PfcBK"};